var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"game",class:[
        'game--'+_vm.snakeCase(_vm.bet.code),
        _vm.sizeClass,
        _vm.iconed ? 'game--iconed games__list__link' : '',
        _vm.active ? 'is-active' : '',
        _vm.isBooster ? 'game--boosted' : ''
    ],attrs:{"title":_vm.name_inner}},[_vm._v("\n   "+_vm._s(_vm.bet.title ? _vm.bet.title : _vm.bet.code)+"\n\n   "),(_vm.isBooster)?_c('span',{staticClass:"game__tooltip"},[_vm._v("\n       "+_vm._s(_vm.bet.title ? _vm.bet.title : _vm.bet.code)+"\n      "),_c('br'),_vm._v("\n      Boost "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatToMoney(_vm.bet.booster * 100, 0, true))}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }